import dayjs from 'dayjs'
// 导入插件（都在 dayjs 包里，无需额外安装）
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import duration from 'dayjs/plugin/duration';
import relativeTime from 'dayjs/plugin/relativeTime';

// 1. 开启 UTC 模式支持（必选前置）
dayjs.extend(utc)
// 2. 开启时区功能支持
dayjs.extend(timezone)
dayjs.extend(duration);
dayjs.extend(relativeTime);

// 导出配置好的 dayjs
export default dayjs
